var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","color":"secondary","small":"","loading":_vm.loading},on:{"click":_vm.test}},[_vm._v("Test FCM")])
}
var staticRenderFns = []

export { render, staticRenderFns }